<template>
  <div>
    <InsightsBanner />
    <InsightsPerformance />
    <div class="tw:bg-white" v-if="isPro && isCancelledSubscription">
      <ProToPlusReactivationBanner
        :itemId="selectedAccommodationId"
        class="tw:items-start tw:mx-auto tw:w-full tw:px-4 tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:pb-11 tw:flex-col"
      />
    </div>
    <InsightsBenefits />
    <InsightsSmartTips />
    <InsightsResources />
    <InsightsCallBanner />
  </div>
</template>
<script setup>
import InsightsBanner from '@/components/studioPlus/insights/InsightsBanner.vue'
import InsightsBenefits from '@/components/studioPlus/insights/InsightsBenefits.vue'
import InsightsPerformance from '@/components/studioPlus/insights/InsightsPerformance.vue'
import InsightsSmartTips from '@/components/studioPlus/insights/InsightsSmartTips.vue'
import InsightsResources from '@/components/studioPlus/insights/InsightsResources.vue'
import InsightsCallBanner from '@/components/studioPlus/insights/InsightsCallBanner.vue'
import ProToPlusReactivationBanner from '@/components/homePage/studioPlus/ProToPlusReactivationBannerContainer.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries/index.js'

const { isCancelledSubscription, isPro } = useStudioPlusCampaign(selectedAccommodationId)
</script>
